<ion-card>
  <ion-card-header>
    <ion-card-title>Postakönyv</ion-card-title>
    <ion-card-subtitle>
      A kimenő küldemények nyilvántartása: feladás napja, ragszám, és a tértivevény
      visszaérkezése. Az ügyirat képernyőjén a „Postázás" gomb hozza ide az iratot.
    </ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div class="ikt-fejsor">
      <ion-button size="small" (click)="ujForm = !ujForm">
        <ion-icon slot="start" name="add-outline"></ion-icon>Új küldemény
      </ion-button>
    </div>

    <div class="ikt-fejsor" *ngIf="ujForm">
      <ion-input label="Irat azonosító" label-placement="stacked" [(ngModel)]="uj.irat"></ion-input>
      <ion-input label="Címzett" label-placement="stacked" [(ngModel)]="uj.cimzett_nev"></ion-input>
      <ion-input label="Cím" label-placement="stacked" [(ngModel)]="uj.cimzett_cim"></ion-input>
      <ion-select label="Mód" label-placement="stacked" interface="popover" [(ngModel)]="uj.kuldes_mod">
        <ion-select-option value="ajanlott">ajánlott</ion-select-option>
        <ion-select-option value="tertivevenyes">tértivevényes</ion-select-option>
        <ion-select-option value="egyszeru">egyszerű</ion-select-option>
        <ion-select-option value="email">e-mail</ion-select-option>
        <ion-select-option value="hivatali_kapu">hivatali kapu</ion-select-option>
        <ion-select-option value="szemelyes">személyes átvétel</ion-select-option>
      </ion-select>
      <ion-button size="small" (click)="felvesz()">Felvétel</ion-button>
    </div>

    <div *ngIf="betoltes" class="ion-text-center ion-padding"><ion-spinner name="crescent"></ion-spinner></div>

    <div class="ikt-tabla-doboz" *ngIf="!betoltes">
      <table class="ikt-tabla">
        <thead>
          <tr><th>Iktatószám</th><th>Tárgy</th><th>Címzett</th><th>Mód</th><th>Állapot</th>
              <th class="szam">Feladva</th><th>Ragszám</th><th class="szam">Kézbesítve</th><th>Művelet</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let s of sorok">
            <td class="iktszam">{{ s.iktatoszam }}</td>
            <td>{{ s.targy }}</td>
            <td>{{ s.cimzett_nev }}</td>
            <td>{{ s.kuldes_mod }}</td>
            <td>{{ allapotNev(s) }}<br><small *ngIf="s.hiba" style="color:var(--ion-color-danger)">{{ s.hiba }}</small></td>
            <td class="szam">{{ s.feladva || '—' }}</td>
            <td>{{ s.ragszam || '—' }}</td>
            <td class="szam">{{ s.kezbesitve || '—' }}</td>
            <td>
              <ion-button size="small" fill="clear" *ngIf="!s.feladva"
                          (click)="modosit(s, { feladva: ma(), statusz: 'feladva' })">Feladva</ion-button>
              <ion-button size="small" fill="clear" *ngIf="s.feladva && !s.kezbesitve"
                          (click)="modosit(s, { kezbesitve: ma(), statusz: 'kezbesitve' })">Kézbesítve</ion-button>
              <!--  A küldemény életútja (feladási/letöltési igazolások) a kézbesítési naplóban
                    van, egy helyen minden csatornára – innen oda ugrunk, erre a sorra szűrve. -->
              <ion-button size="small" fill="clear" (click)="eletut(s)" title="Hol tart a küldemény?">
                <ion-icon slot="icon-only" name="navigate-circle-outline"></ion-icon>
              </ion-button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="ikt-ures" *ngIf="!sorok.length">A postakönyv üres.</div>
    </div>
  </ion-card-content>
</ion-card>
